<template>
  <div
    data-component-id="AddCandidate"
  >
    <v-card
      :style="`z-index: 10; position: sticky; top: ${focusModeToolbarTop};`"
      color="rgba(255, 255, 255, 0.8)"
    >
      <div
        class="
          persistent-scrollbar
          overflow-x-auto overflow-hidden
        "
        style="display: grid;"
      >
        <ListItemForCandidates
          v-if="foundedCollaborator"
          :item="foundedCollaborator"
          style="background: #b3e5fc91;"
          is-transparent
        />
      </div>

      <v-toolbar
        flat
        color="transparent"
      >
        <section
          class="
            d-flex align-center col-12
            px-0
          "
          style="height: 100%; gap: 16px;"
        >
          <v-btn small icon fab class="px-0" text @click="$router.back()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <v-toolbar-title>Créer un Candidate</v-toolbar-title>
        </section>
      </v-toolbar>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      />
    </v-card>

    <section
      class="my-8 my-lg-16 px-4 px-md-8 col-12 py-0"
      :class="{ 'mt-12' : focusMode }"
    >
      <v-expansion-panels
        mandatory
        flat
      >
        <Application
          :fields="forms.personalInformation.fields"
          title="Coordonnées"
          :application="collaborator"
          :is-loading="isLoading"
          permission="PROSPECT"
          is-create-mode
          hide-expand-icon
          @save-changes="(data) => updateProspect({ uuid: collaborator.uuid, ...data, ...input }, false)"
        />
      </v-expansion-panels>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { requests } from '@/mixins/index';

import Application from '@/components/application/Application.vue';
import ListItemForCandidates from '@/components/table/components/ListItemForCandidates.vue';

export default {
  name: 'AddCandidate',
  components: { Application, ListItemForCandidates },
  data () {
    return {
      collaborator: {},
      forms: {
        personalInformation: {
          fields: [
            {
              name: 'firstname',
              label: 'Prénom',
              viewType: 'Text',
              icon: 'account',
              type: 'text',
              required: true,
              mandatory: true
            },
            {
              name: 'lastname',
              label: 'Nom',
              viewType: 'Text',
              icon: 'account',
              type: 'text',
              required: true,
              mandatory: true
            },
            {
              name: 'birth_date',
              label: 'Date de naissance',
              component: 'DatePicker',
              icon: 'calendar',
              type: 'date',
              min: '1920-01-01',
              required: true,
              mandatory: true
            },
            {
              name: 'mobilephone',
              label: 'Mobile',
              component: 'MobilePhoneInput',
              icon: 'phone',
              type: 'phone',
              required: true,
              mandatory: true
            },
            {
              name: 'email',
              label: 'E-mail',
              viewType: 'Text',
              icon: 'email',
              type: 'text',
              required: true,
              mandatory: true,
              rules: [
                value => {
                  const emailRegex = /^(?=[^\s@]{0,64}@)[^\s@]+@[^\s@]+\.[^\s@.]+$/;
                  return emailRegex.test(value) || 'Format d\'email invalide';
                }
              ]
            }
          ]
        }
      },
      input: {},
      foundedCollaborator: null,
      isLoading: false
    };
  },
  computed: {
    ...mapState(['focusMode']),
    ...mapGetters(['canPerformAction']),
    collaboratorName () {
      return collaborator => `${collaborator.firstname} ${collaborator.lastname}`;
    },
    focusModeToolbarTop () {
      if (this.$vuetify.breakpoint.xsOnly) {
        return '64px';
      }
      return this.focusMode ? '24px' : '88px';
    }
  },
  methods: {
    async updateProspect (input) {
      if (!this.canPerformAction('CREATE_PROSPECT')) return;

      this.handleLoading(true);

      const response = await requests.updateProspect({ input: this.transformInputForCreateMode(input), isEditMode: false });

      if (!response.success) {
        this.$store.commit('setSnackbar', {
          text: 'Erreur d’enregistrement : Ce candidat existe déjà dans le système.',
          color: 'lightBlue'
        });

        this.foundedCollaborator = response.data;
      } else {
        const { collaborator } = response.data;
        this.$router.push({ name: 'candidate', params: { candidateUuid: collaborator.uuid } });

        this.$store.commit('setSnackbar', {
          text: 'Enregistrer avec succès.',
          color: 'success'
        });
      }

      this.handleLoading(false);
    },
    transformInputForCreateMode (input) {
      return {
        email: input.email,
        mobilePhone: input.mobilephone.replaceAll(' ', ''),
        firstName: input.firstname,
        lastName: input.lastname,
        birthDate: input.birth_date,
        newsletters: input.newsletters
      };
    },
    handleLoading (value) {
      this.isLoading = value;
    }
  }
};
</script>

<style>
.v-list-item__subtitle,
.v-list-item__title {
  white-space: break-spaces;
}

.switch-flex-column.v-input--switch .v-input__slot {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.vue-tel-input.vue-tel-input {
  border-top: 0;
  border-right: 0;
  border-left: 0;

  &:focus-within {
    box-shadow: none;
    border-color: #c71900;
  }
}
</style>
